import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pop-paquete',
  templateUrl: './pop-paquete.component.html',
  styleUrls: ['./pop-paquete.component.scss'],
})
export class PopPaqueteComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
